import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SIZES } from '../../../constants'
import ContainerRow from './ContainerRow'
import LeftColumn from './LeftColumn'
import RightColumn from './RightColumn'
import FirstImageBox from './FirstImageBox'
import SmallImageBox from './SmallImageBox'
import UTM from '../../utils/UTM'

class Dynamiclead extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      firstImageSize: this.calculateFirstImageSize()
    }
  }

  componentWillMount () {
    if (typeof window !== 'undefined') {
      window.onresize = () => {
        const {
          firstImageSize
        } = this.state

        const newSize = this.calculateFirstImageSize()

        if (firstImageSize !== newSize) {
          this.setState({
            firstImageSize: newSize
          })
        }
      }
    }
  }

  calculateFirstImageSize () {
    let size = '1_1L'

    if (typeof window !== 'undefined' && window.innerWidth < SIZES.BREAKPOINT_MD) {
      size = '4_3L'
    }

    return size
  }

  render () {
    const {
      titleComponent: TitleComponent,
      widget: {
        boxes: originalBoxes,
        name,
        utmContent,
        utmMedium,
        utmSource,
        imageSize
      }
    } = this.props

    const {
      firstImageSize
    } = this.state

    if (!originalBoxes.length) return null

    const boxes = Object.assign([], originalBoxes)
    let firstBox = boxes.shift()

    const firstBoxLink = new UTM(firstBox.link).getUTMLink({
      utmContent,
      utmMedium,
      utmSource,
      utmTerm: 'position-0',
      utmCampaign: firstBox.source
    })

    firstBox = Object.assign({}, firstBox, {
      image: firstBox.images[firstImageSize],
      link: firstBoxLink
    })

    return (
      <ContainerRow id={name}>
        <LeftColumn>
          <FirstImageBox box={firstBox} key={firstBox.guid} featuredClass='big'>
            <TitleComponent box={firstBox}/>
          </FirstImageBox>
        </LeftColumn>
        <RightColumn>
          {
            boxes.map(box => {
              const link = new UTM(box.link).getUTMLink({
                utmContent,
                utmMedium,
                utmSource,
                utmTerm: `position-${originalBoxes.indexOf(box)}`,
                utmCampaign: box.source
              })

              const boxWithImageAndLink = Object.assign({}, box, {
                image: box.images[imageSize],
                link
              })

              return (
                <SmallImageBox box={boxWithImageAndLink} key={box.guid} featuredClass='small'>
                  <TitleComponent box={boxWithImageAndLink}/>
                </SmallImageBox>
              )
            })
          }
        </RightColumn>
      </ContainerRow>
    )
  }
}

Dynamiclead.propTypes = {
  widget: PropTypes.object.isRequired
}

export default Dynamiclead
